import type { AutomationFailureResponse } from '@urbanx/agx.support.client';
import { AgxCollapsible, AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import {
  formatAutomationFailureInstant,
  getAutomationResolutionLabel,
} from './automationFailurePresentation';

interface AutomationFailureResolutionHistoryProps {
  history: NonNullable<AutomationFailureResponse['resolutionHistory']>;
  getStaffName: (staffUserId?: string) => string;
}

const AutomationFailureResolutionHistory = ({
  history,
  getStaffName,
}: AutomationFailureResolutionHistoryProps) => (
  <AgxCollapsible
    title="Action history"
    variant="withoutDivider"
    backgroundColor="none"
    open
    showBorder
    enableToggle
    headerPadding={{ top: 'md', bottom: 'md', left: 'lg', right: 'lg' }}
    contentPadding={{ top: '3xs', bottom: 'md', left: 'lg', right: 'lg' }}
    content={
      <AgxSpacer direction="vertical" gap="spacing-md">
        {history.map((resolution, index) => (
          <AgxSpacer key={resolution.resolvedUtc ?? index} direction="vertical" gap="2xs">
            <AgxTypography
              id={`automation-failure-resolution-${index}`}
              type="body_ui_strong"
              size="small"
            >
              {getAutomationResolutionLabel(resolution.type)} by{' '}
              {getStaffName(resolution.staffUserId)}
            </AgxTypography>
            <AgxTypography
              id={`automation-failure-resolution-date-${index}`}
              type="body_ui"
              size="small"
            >
              {formatAutomationFailureInstant(resolution.resolvedUtc)}
            </AgxTypography>
            {resolution.reopenedUtc && (
              <AgxTypography
                id={`automation-failure-reopened-${index}`}
                type="body_ui"
                size="small"
              >
                Reopened by {getStaffName(resolution.reopenedByStaffUserId)} on{' '}
                {formatAutomationFailureInstant(resolution.reopenedUtc)}
              </AgxTypography>
            )}
          </AgxSpacer>
        ))}
      </AgxSpacer>
    }
  />
);

export default AutomationFailureResolutionHistory;
